module.exports = __webpack_public_path__ + "static/img/illustration_rescue_list_data_stack.f4ee471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/illustration_rescue_list_data_stack.png
// module id = JeTI
// module chunks = 1